// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7fb6a12","732":"bb98f86f","977":"fb303330"}[chunkId] + ".chunk.js";
};